<template>
  <article class="record-row" :class="{ 'record-row--clickable': clickable }" :role="clickable ? 'button' : null" :tabindex="clickable ? 0 : null" @click="activate" @keydown.enter.prevent="activate" @keydown.space.prevent="activate">
    <div class="record-icon"><v-icon>{{ icon }}</v-icon></div>
    <div class="record-copy">
      <strong>{{ title }}</strong>
      <span>{{ subtitle }}</span>
    </div>
    <div class="record-end">
      <strong v-if="amount !== undefined">{{ amount | currency }}</strong>
      <small>{{ status }}</small>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PortalRecordRow',
  props: {
    icon: String,
    title: String,
    subtitle: String,
    amount: [Number, String],
    status: String,
    clickable: Boolean,
  },
  methods: {
    activate() {
      if (this.clickable) this.$emit('click');
    },
  },
};
</script>
